// I put this form inside OrderView because I don't want it to be used in other places
import React from "react";
import request from "lib/request";
import Confirm from "Confirm";

class RefundForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showRefundForm: false,
      refundAmount: "",
      refundError: "",
    };
  }

  handleRefundClick = () => {
    this.setState({ showRefundForm: true, refundError: "", refundAmount: "" });
  };

  handleRefundAmountChange = (e) => {
    const value = e.target.value;
    if (isNaN(value) || Number(value) < 0) {
      this.setState({ refundError: "Amount must be a positive number" });
    } else if (Number(value) > Number(this.props.order.chargeTotal)) {
      this.setState({ refundError: "Amount cannot exceed order total" });
    } else {
      this.setState({ refundError: "" });
    }
    this.setState({ refundAmount: value });
  };

  handleRefundSubmit = async () => {
    if (!this.state.refundAmount || Number(this.state.refundAmount) <= 0) {
      this.setState({ refundError: "Enter a valid amount" });
      return;
    }
    if (Number(this.state.refundAmount) > Number(this.props.order.chargeTotal)) {
      this.setState({ refundError: "Amount cannot exceed order total" });
      return;
    }
    this.setState({ refundError: "" });
    try {
      await request.post(`${this.props.dataSource}/${this.props.order.id}/refund`,
        {
          amount: this.state.refundAmount
      });
      this.setState({ showRefundForm: false });
      if (this.props.onRefunded) this.props.onRefunded();
    } catch (err) {
      const serverMessage = err && err.response && err.response.data && err.response.data.error;
      this.setState({ refundError: serverMessage || "Refund failed" });
    }
  };

  render() {
    const { order } = this.props;
    return (
      <div>
        {order.refunded && (
          <p>
            <span className="has-text-weight-bold">Refunded</span>
            <span className="ml-2">${order.refunded}</span>
          </p>
        )}
        {(!this.state.showRefundForm && !order.refunded) && (
          <a className="button" href="#" onClick={e => { e.preventDefault(); this.handleRefundClick(); }}>
            Start Refund
          </a>
        )}
        {this.state.showRefundForm && (
          <form onSubmit={(e)=>{e.preventDefault()}} className="mt-3">
            <div className="field">
              <label className="label">Refund Amount</label>
              <div className="control has-icons-left">
                <span className="icon is-small is-left">
                  <i className="fas fa-dollar-sign" />
                </span>
                <input
                  className="input"
                  type="number"
                  min="0"
                  max={order.chargeTotal}
                  step="0.01"
                  value={this.state.refundAmount}
                  onChange={this.handleRefundAmountChange}
                  placeholder={`Max $${order.chargeTotal}`}
                />
              </div>
              {this.state.refundError && <p className="help is-danger">{this.state.refundError}</p>}
            </div>
            <div className="buttons is-flex is-align-items-center">
              <Confirm
                message="Are you sure you want to refund this order?"
                action={this.handleRefundSubmit}
              >
                <button
                  className="button is-primary"
                  type="button"
                  disabled={!!this.state.refundError || !this.state.refundAmount}
                >
                  Refund
                </button>
              </Confirm>
              <button className="button ml-2" type="button" onClick={() => this.setState({ showRefundForm: false })}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    );
  }
}

export default RefundForm;
